import { Checkbox, Dialog, DialogActions, Typography } from "@mui/material";
import AlertTriangle from '../../../../assets/svg/routing/alert-triangle.svg'

import React, { useState } from 'react'
import { Close } from "@mui/icons-material";
import { colorBrandObject } from "../../../../constants/brandings";
import CustomButton from "../../../reusableComponents/CustomButton";

function FallbackRoutingModal({ fallbackRoutingModal, setFallbackRoutingModal, onClick }) {
  const [checked, setChecked] = useState(false)
  const handleKeyDownFallback = (event) => {
    if (event.key === "Escape") {
      setFallbackRoutingModal(false);
    }
  };
  const handleChecked = (e) => {
    let value = e?.target?.checked
    setChecked(value)
  }

  return (
    <Dialog
      open={fallbackRoutingModal}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          width: "650px",
          maxWidth: "650px",
          height: "310px"
        },
      }}
      onKeyDown={handleKeyDownFallback}
    >
      <div className="" >

        <div className='d-flex align-items-center w-100 justify-content-between' style={{ padding: "24px 24px 0px 24px" }}>
          <div className='d-flex align-items-center  justify-content-start' style={{ gap: 10 }}>
            <AlertTriangle />
            <Typography sx={{
              color: "#1D1C20",
              fontWeight: 600
            }}>Are you sure you want to disable dynamic routing? </Typography>
          </div>
          <Close style={{ cursor: "pointer" }} onClick={() => setFallbackRoutingModal(false)} />
        </div>
        <hr />

        <div className="px-4">
          <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#2D2B32", letterSpacing: "-0.1px" }}>Disabling this fallback mechanism may increase the likelihood of payment failures.</Typography>
          <div className="mt-4 d-flex align-items-center">
            <Checkbox
              sx={{
                "& .MuiSvgIcon-root": {
                  color: "#D9D9D9",
                },
                "&.Mui-checked": {
                  color: colorBrandObject?.primary,
                  "& .MuiSvgIcon-root": {
                    fill: colorBrandObject?.primary,
                  },
                },
              }}
              style={{
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "12px",
                height: "14px",
                color: "rgba(36, 183, 170, 1)",
                marginRight: "8px",
              }}
              id={"dynamicRouting"}
              checked={!!checked}
              value={checked}
              onChange={handleChecked}
            />
            <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#2D2B32", letterSpacing: "-0.2px" }}>I understand the consequence of this action and I agree to disabling this feature.</Typography>
          </div>
        </div>
      </div>

      <div className="modalBottomBar" >
        <CustomButton text={"Disable"} onClick={onClick} disabled={!checked} variant={"contained"} type={"secondary"} />
      </div>
    </Dialog>
  )
}

export default FallbackRoutingModal

